import axios from 'axios';

const updateMetrics = metrics => axios.put('metrics', { metrics });

const exportMetric = ({ id, start, end, compare, raw }) => {
  return axios.post(`metrics/${id}/export`, { start, end, compare, raw });
};

// Resolves with a Blob, or { queued: true } when the export was too large to build inline.
const downloadMetricCsv = async ({ id, start, end, compare, raw }) => {
  const response = await axios.get(`metrics/${id}/export/download`, {
    params: { start, end, compare, raw },
    responseType: 'blob'
  });

  if (response.status === 202) {
    return { queued: true };
  }

  return { queued: false, blob: response.data };
};

export { updateMetrics, exportMetric, downloadMetricCsv };
